{
    "name": "booking-drawer-mfe",
    "version": "5.6.1",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "start:dev": "ng serve --configuration=development",
        "start:prod": "ng serve --configuration=production",
        "build": "ng build",
        "build:dev": "ng build --configuration=development",
        "build:prod": "ng build --configuration=production",
        "watch": "ng build --watch --configuration development",
        "test": "jest",
        "test:coverage": "jest --coverage",
        "test:watch": "jest --watch",
        "lint": "ng lint",
        "lint:fix": "ng lint --fix",
        "prepare": "husky",
        "cert:generate": "mkdir -p ./tls & mkcert -cert-file ./tls/localhost.booking-drawer.ram.dev.syniotec.com-cert.pem -key-file ./tls/localhost.booking-drawer.ram.dev.syniotec.com-key.pem -ecdsa localhost.booking-drawer.ram.dev.syniotec.com 127.0.0.1 ::1"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "19.2.14",
        "@angular/cdk": "19.2.19",
        "@angular/common": "19.2.14",
        "@angular/compiler": "19.2.14",
        "@angular/core": "19.2.14",
        "@angular/forms": "19.2.14",
        "@angular/google-maps": "19.2.19",
        "@angular/material": "19.2.19",
        "@angular/platform-browser": "19.2.14",
        "@angular/platform-browser-dynamic": "19.2.14",
        "@angular/router": "19.2.14",
        "@ngrx/component-store": "19.2.1",
        "@ngrx/effects": "19.2.1",
        "@ngrx/operators": "19.2.1",
        "@ngrx/signals": "19.2.1",
        "@ngrx/store": "19.2.1",
        "@ngx-translate/core": "^17.0.0",
        "@sharemactechhub/frontend-library": "19.0.144",
        "@syniotec-techhub/assets": "1.21.1",
        "@syniotec-techhub/common": "19.26.1",
        "@syniotec-techhub/core": "19.24.6",
        "@syniotec-techhub/ui": "19.42.0",
        "es-module-shims": "^1.10.1",
        "moment": "^2.30.1",
        "moment-timezone": "^0.5.48",
        "ngx-cookie-service": "^19.1.0",
        "ngx-infinite-scroll": "19.0.0",
        "ngx-mask": "19.0.6",
        "ngx-permissions": "^19.0.0",
        "rxjs": "~7.8.0",
        "tslib": "^2.8.1",
        "zone.js": "^0.15.0"
    },
    "devDependencies": {
        "@angular-architects/native-federation": "19.0.23",
        "@angular-devkit/architect": "0.1901.9",
        "@angular-devkit/build-angular": "19.2.15",
        "@angular-eslint/eslint-plugin": "^19.8.1",
        "@angular-eslint/eslint-plugin-template": "^19.8.1",
        "@angular-eslint/template-parser": "^19.8.1",
        "@angular/build": "19.2.15",
        "@angular/cli": "19.2.15",
        "@angular/compiler-cli": "19.2.14",
        "@commitlint/cli": "^20.1.0",
        "@commitlint/config-conventional": "^20.0.0",
        "@happy-dom/jest-environment": "^14.12.3",
        "@ngrx/eslint-plugin": "^19.2.1",
        "@ngrx/schematics": "^19.2.1",
        "@smarttools/eslint-plugin-rxjs": "^1.0.18",
        "@types/google.maps": "^3.55.12",
        "@types/jest": "^29.5.12",
        "@types/node": "20.14.9",
        "@typescript-eslint/eslint-plugin": "^8.24.1",
        "@typescript-eslint/parser": "^8.24.1",
        "angular-eslint": "19.1.0",
        "eslint": "^9.20.1",
        "eslint-config-prettier": "^10.0.1",
        "eslint-plugin-prettier": "^5.2.3",
        "eslint-plugin-unused-imports": "^4.1.4",
        "globals": "^15.15.0",
        "husky": "^9.1.4",
        "jest": "^29.7.0",
        "jest-junit": "^16.0.0",
        "jest-preset-angular": "^14.2.2",
        "lint-staged": "^15.2.7",
        "prettier": "^3.7.4",
        "pretty-quick": "^4.2.2",
        "ts-node": "^10.9.2",
        "typescript": "^5.4.5",
        "typescript-eslint": "8.23.0"
    },
    "lint-staged": {
        "*.{ts,css,scss,html,json}": [
            "prettier --write"
        ],
        "*.{ts,tsx}": [
            "eslint"
        ]
    }
}
